import _get from 'lodash/get';
import _map from 'lodash/map';
import { UseBulkSelectResult } from '@lib/hooks/useTableItemsBulkSelect';
import { BaseItem } from '@lib/components/Table/types';

interface Args<T extends BaseItem> {
  action: (ids: string[]) => void;
  onGetAllIds: () => Promise<string[]> | undefined;
  useBulkSelectResult?: UseBulkSelectResult<T>;
}

export default function tableItemsBulkAction<T extends BaseItem>(
  args: Args<T>,
) {
  const { action, onGetAllIds, useBulkSelectResult } = args;
  const selectedTableItems = _get(useBulkSelectResult, 'selectedTableItems');
  const selectedSingleTableItemId = _get(useBulkSelectResult, [
    'selectedSingleTableItem',
    'id',
  ]) as string;
  const isAllTableItemsSelected = _get(
    useBulkSelectResult,
    'isAllTableItemsSelected',
  );
  if (selectedSingleTableItemId) {
    action([selectedSingleTableItemId]);
  } else if (selectedTableItems?.length && !isAllTableItemsSelected) {
    action(_map(selectedTableItems, 'id') as string[]);
  } else if (isAllTableItemsSelected) {
    onGetAllIds()?.then((ids) => {
      if (ids?.length) {
        action(ids);
      }
    });
  } else {
    action([]);
  }
}
